import server from 'utils/server';

const paymentService = {
  checkout: () => server.get('payment/checkout'),
  retrive: (session_id) => server.get(`payment/retrieve?session_id=${session_id}`)
};

export default paymentService;
